import { useHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import type { FC } from 'react';
import { FormField } from '../FormField/FormField';
import { TextInput } from '../TextInput/TextInput';
import type { TextFieldProps } from './TextField.types';

export const TextField: FC<TextFieldProps> = ({
  className,
  inputWidthClassName,
  error,
  name,
  value = '',
  ...props
}) => {
  const textInputId = useHtmlId('textInput');
  const id = props.id ?? textInputId;
  return (
    <FormField className={className} error={error} htmlFor={id} {...props}>
      <TextInput
        {...props}
        value={value}
        hasError={props.hasError || error !== undefined}
        name={name}
        id={id}
        className={inputWidthClassName}
      />
    </FormField>
  );
};
